/** NOTE: Keep map ordered by experiment id */
module.exports = {
    // // TODO Check Open Experiment Status
    CHAM_GOATS_POST_FMP_MORE_GIGS_V4: 4282,
    HAWKS_CONTINUE_CTA_COPY: 4366,
    HAWKS_DQA_INTEGRATION_FIRST_PHASE: 4879,
    HAWKS_ADD_TIMEOUT_TO_ADDITIONAL_DATA: 4932,
    LYNXES_GIG_PAGE_CTA_REWORK: 5088,
};
